import { Pencil } from "lucide-react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import useLocationMediaList from "../../../containers/FacilityDetailsPage/hooks/useLocationMediaList";
import { RecentMediaList } from "../../DashboardComponents/RecentMediaList";
import { ModalUploadMedia } from "../../MediaComponents/ModalUploadMedia";

import "./styles.scss";

interface IRecentMediaUploadsSectionProps {
  locationId: string;
}

export const RecentMediaUploadsSection: React.FunctionComponent<
  IRecentMediaUploadsSectionProps
> = ({ locationId }) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityDetailsPage.recentMediaUploads.${key}`);
  const history = useHistory();

  const { data } = useLocationMediaList(locationId);
  const recentMediaList = data ?? [];

  const [showUploadModal, setShowUploadModal] = useState(false);

  const handleViewMore = () => {
    history.push(`/location/${locationId}/media`);
  };

  return (
    <div className="recent-media-uploads-container">
      <RecentMediaList
        dataList={recentMediaList.slice(0, 5)}
        hideLocationName
      />
      <div className="media-uploads-button-group">
        {recentMediaList.length > 0 && (
          <button className="btn btn-border" onClick={handleViewMore}>
            {t("view_more")}
          </button>
        )}
        <button
          className="btn btn-blue btn-new-media"
          onClick={() => setShowUploadModal(true)}
        >
          <Pencil size={16} color="white" className="pencil-icon" />
          {t("post")}
        </button>
      </div>
      {showUploadModal && (
        <ModalUploadMedia
          locationId={locationId}
          onClose={() => setShowUploadModal(false)}
        />
      )}
    </div>
  );
};

export default RecentMediaUploadsSection;
